import React, {
  createContext,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import * as apiInit from "../utils/ApiInit.ts";
import Icon from "../components/widgets/Icon";

interface InitDataContableContextInterface {
  centrosCosto: any[];
  cuentasContables: any[];
  itemsContables: any[];
  naturalezasContables: any[];
  presupuestos: any[];
  isTutorialActive: boolean;
  setIsTutorialActive: Dispatch<SetStateAction<any>>;
}

const defaultState: InitDataContableContextInterface = {
  centrosCosto: [],
  cuentasContables: [],
  itemsContables: [],
  naturalezasContables: [],
  presupuestos: [],
  isTutorialActive: false,
  setIsTutorialActive: () => {},
};

const InitDataContableContext = createContext(defaultState);

type InitDataContableProviderProps = {
  children: React.ReactNode;
};

const InitDataContableProvider = ({
  children,
}: InitDataContableProviderProps) => {
  const componentIsMounted = useRef(true);
  const [cuentasContables, setCuentasContables] = useState<any[]>([]);
  const [itemsContables, setItemsContables] = useState<any[]>([]);
  const [naturalezasContables, setNaturalezasContables] = useState([]);
  const [presupuestos, setPresupuestos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isTutorialActive, setIsTutorialActive] = useState(false);
  const [centrosCostoFull, setCentrosCostoFull] = useState([]);
  const [centrosCosto, setCentrosCosto] = useState([]);

  useEffect(() => {
    const isTutorialActiveVar = localStorage.getItem("isTutorialActive");
    if (isTutorialActiveVar === null) {
      setIsTutorialActive(false);
    } else if (isTutorialActiveVar === "false") {
      setIsTutorialActive(false);
    } else if (isTutorialActiveVar === "true") {
      setIsTutorialActive(true);
    }
  }, []);

  const fetchCentrosCosto = async () => {
    if (localStorage.getItem("centrosCosto") === null) {
      const response =
        await apiInit.GET_INIT_DATA_CENTROS_COSTO.getInitDataCentrosCosto();
      if (response !== null) {
        setCentrosCostoFull(response);

        const arr = JSON.parse(JSON.stringify(response));
        arr.forEach((obj: { [x: string]: any }) => {
          delete obj.id_area;
          delete obj.codigo;
          delete obj.old_id;
          delete obj.activo;
          delete obj.dt_cre;
          delete obj.dt_mod;
        });
        setCentrosCosto(arr);

        localStorage.setItem("centrosCosto", JSON.stringify(arr));
      }
    } else {
      const centrosCostoStorage = JSON.parse(
        localStorage.getItem("centrosCosto") || "[]",
      );
      setCentrosCosto(centrosCostoStorage);
    }
  };

  const fetchInitDataCuentaContable = async () => {
    const response =
      await apiInit.GET_INIT_DATA_CUENTAS_CONTABLES.getInitDataCuentasContables();

    if (response) {
      //console.log("HOLA: ", response);
      setCuentasContables(response);
    } else {
      console.log("sin respuesta init data contable");
    }
  };

  const fetchInitDataCuentasContablesItems = async () => {
    const response =
      await apiInit.GET_INIT_DATA_CUENTAS_CONTABLES_ITEMS.getInitDataCuentasContablesItems();

    if (response !== null) {
      setItemsContables(response);
    }
  };

  const fetchCuentasItemsNaturalezas = async () => {
    const response =
      await apiInit.GET_CUENTAS_CONTABLES_ITEMS_NATURALEZAS.getCuentasContablesItemsNaturalezas();

    if (response !== null) {
      setNaturalezasContables(response);
    }
  };

  const fetchPresupuestos = async () => {
    const response = await apiInit.GET_PRESUPUESTOS.getPresupuestos();

    if (response !== null) {
      setPresupuestos(response);
    }
  };

  useEffect(() => {
    // Using an IIFE
    (function () {
      try {
        fetchInitDataCuentaContable();
        fetchInitDataCuentasContablesItems();
        fetchCuentasItemsNaturalezas();
        fetchPresupuestos();
        const centrosCostoStored = localStorage.getItem("centrosCosto") || null;

        if (centrosCostoStored === null) {
          fetchCentrosCosto();
        } else {
          setCentrosCosto(JSON.parse(centrosCostoStored));
        }

        if (!window.location.hash) {
          window.location.href = window.location.href + "#loaded";
          window.location.reload();
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    })();

    return () => {
      componentIsMounted.current = false;
    };
  }, []);

  if (!loading) {
    return (
      <InitDataContableContext.Provider
        value={{
          centrosCosto,
          cuentasContables,
          itemsContables,
          naturalezasContables,
          presupuestos,
          isTutorialActive,
          setIsTutorialActive,
        }}
      >
        {!loading ? children : null}
      </InitDataContableContext.Provider>
    );
  } else {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Icon
          icon={"spinner"}
          className="fa-spin"
          style={{ fontSize: "50px" }}
        />
      </div>
    );
  }
};

export { InitDataContableContext, InitDataContableProvider };
